/**
 * @fileoverview DELETE handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id/message/:message_variation_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../../../reactQueryFetcherAdapters";
import { appGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationIdCacheKeys } from "./constants";
import type {
  DeleteAppGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationIdProps,
  DeleteMessageResult,
} from "./types";

export const deleteMessage = reactQueryMutationAdapter(
  appGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationIdCacheKeys,
  (
    props: DeleteAppGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationIdProps
  ): Promise<DeleteMessageResult> => {
    return fetch(
      `/${props.appGroupId}/canvas/${props.workflowId}/step/${props.stepId}/message/${props.messageVariationId}`,
      "DELETE",
      undefined,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
